import { Text } from 'blaze-ui/Text/Text'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { Plus } from 'blaze-ui/icons'
import { BrandKitCreationDrawer } from 'components/BrandKitCreationDrawer/BrandKitCreationDrawer'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const BrandKitsMobileTopBar = () => {
  const { drawersStore } = useRootStore()
  const { openDrawer } = drawersStore
  const theme = useHeaderTheme()
  const { isIOSNative } = useResponsiveDesign()
  const workspace = useCurrentWorkspace()
  const isAutopilot = !!workspace?.is_virtual_marketer

  if (isAutopilot && isIOSNative) {
    return null
  }

  const canCreateBrandKit = !isAutopilot
  const title = isAutopilot ? 'Brand Kit' : 'Brand Kits'

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        {isIOSNative ? <MobileTopBarContainer.BackButton /> : <UnlockButton />}
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text lineClamp={1}>{title}</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        {canCreateBrandKit && (
          <Button
            frontIcon={Plus}
            onPress={() => openDrawer(BrandKitCreationDrawer)}
            variant="editor"
            rounded
            aria-label="Create Brand Kit"
          >
            New
          </Button>
        )}
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
